// extracted by mini-css-extract-plugin
module.exports = {"InfoModal":"InfoModal_InfoModal__n1_KN","OkBtn":"InfoModal_OkBtn__WVPG1"};